import { GROUP_SEPARATOR } from "./services";
import { VariableConfigReportComboApi } from "./types";
import { VariableReportComboUtils } from "./variableUtils";

export const replacePredefinedRanges = (
	value: string,
	date: Date,
	variables?: VariableConfigReportComboApi[],
	variableValues?: Record<string, string>
): string => {
	// Split the string by the custom delimiter (ç)
	const parts = value.split(GROUP_SEPARATOR);

	// Iterate over each part and replace predefined ranges
	const updatedParts = parts.map((part) => {
		const [field, condition] = part.split("=");
		const dateRange = VariableReportComboUtils.parseVariableForValue(condition, date, variables, variableValues);
		if (dateRange) {
			return `${field}=${dateRange}`;
		}

		return part; // Return the original part if no replacement is needed
	});

	// Rejoin the updated parts with the delimiter
	return updatedParts.join(GROUP_SEPARATOR);
};
